module.exports = __webpack_public_path__ + "img/send-express.10a14589.png";